export const BACKEND_UNAVAILABLE_STATUS = "backend_unavailable";

export interface IApiConnectionState {
  unavailable: boolean;
  lastErrorStatus?: string;
  updatedAt: number;
}

type ApiConnectionListener = (state: IApiConnectionState) => void;

const listeners = new Set<ApiConnectionListener>();
let state: IApiConnectionState = {
  unavailable: false,
  updatedAt: Date.now(),
};

const NETWORK_ERROR_CODES = new Set<string>([
  "ERR_NETWORK",
  "ERR_BAD_RESPONSE",
  "ECONNABORTED",
  "ETIMEDOUT",
]);

export function subscribeApiConnectionState(
  listener: ApiConnectionListener
): () => void {
  listeners.add(listener);
  listener(state);
  return () => {
    listeners.delete(listener);
  };
}

export function isBackendUnavailableStatus(
  status: string | undefined | null
): boolean {
  if (!status || typeof status != "string") return false;
  const normalized = status.trim().toLowerCase();
  if (normalized.length == 0) return false;

  if (normalized == BACKEND_UNAVAILABLE_STATUS) return true;
  if (normalized.startsWith("http_5")) return true;
  if (NETWORK_ERROR_CODES.has(normalized.toUpperCase())) return true;
  if (normalized.includes("network error")) return true;
  if (normalized.includes("timeout")) return true;
  return false;
}

export function markApiConnectionUnavailable(status: string) {
  if (!isBackendUnavailableStatus(status)) return;

  if (state.unavailable && state.lastErrorStatus == status) return;
  state = {
    unavailable: true,
    lastErrorStatus: status,
    updatedAt: Date.now(),
  };
  notifyListeners();
}

export function markApiConnectionHealthy() {
  if (!state.unavailable) return;

  state = {
    unavailable: false,
    updatedAt: Date.now(),
  };
  notifyListeners();
}

function notifyListeners() {
  for (const listener of listeners) {
    listener(state);
  }
}
